import { createSelector } from 'reselect';
import { KEY } from './';
import { GlobalState } from 'store/types';

const getTicketTemplatesState = (state: GlobalState) => state[KEY];

const selectTicketTemplates = createSelector(getTicketTemplatesState, (ticketTemplates) =>
  ticketTemplates.ticketTemplates.map((t) => ({ ...t, name: t.type }))
);

const selectAction = createSelector(getTicketTemplatesState, (ticketTemplates) => ticketTemplates.action);

export const selectors = {
  selectTicketTemplates,
  selectAction
};
